import React from 'react';
import Select, { SingleValue, StylesConfig } from 'react-select';

interface Option {
  value: string;
  label: string;
}

const EMPLOYEE_RANGES: Option[] = [
  { value: '1-10', label: '1 – 10' },
  { value: '11-50', label: '11 – 50' },
  { value: '51-200', label: '51 – 200' },
  { value: '201-500', label: '201 – 500' },
  { value: '501-1000', label: '501 – 1,000' },
  { value: '1001+', label: '1,001+' },
];

interface Props {
  value: string;
  onChange: (value: string) => void;
  borderColor?: string;
  isDisabled?: boolean;
  placeholder?: string;
}

export const EmployeeRangeSelect: React.FC<Props> = ({
  value,
  onChange,
  borderColor = '#E5E7EB',
  isDisabled = false,
  placeholder = 'Select employee range...',
}) => {
  const selected = EMPLOYEE_RANGES.find((o) => o.value === value) || null;

  const styles: StylesConfig<Option, false> = {
    control: (base, state) => ({
      ...base,
      borderColor: state.isFocused ? '#3B82F6' : borderColor,
      borderRadius: '0.5rem',
      borderWidth: '1px',
      boxShadow: 'none',
      backgroundColor: '#fff',
      minHeight: '42px',
      '&:hover': { borderColor: '#3B82F6' },
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? '#3B82F6' : state.isFocused ? '#EFF6FF' : '#fff',
      color: state.isSelected ? '#fff' : '#1F2937',
      fontSize: '14px',
    }),
    singleValue: (base) => ({ ...base, fontSize: '14px', color: '#1F2937' }),
    placeholder: (base) => ({ ...base, fontSize: '14px', color: '#9CA3AF' }),
  };

  return (
    <Select
      options={EMPLOYEE_RANGES}
      value={selected}
      onChange={(opt: SingleValue<Option>) => onChange(opt ? opt.value : '')}
      styles={styles}
      placeholder={placeholder}
      isDisabled={isDisabled}
      isSearchable={false}
    />
  );
};
